import React from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';
import DropdownField from './DropdownField';

import ValidatableField from './ValidatableField';
import { FIELD_TYPE } from '../../utility/validators';

import './TermField.css';

const UNITS = [
  { value: 'D', label: 'Days' },
  { value: 'M', label: 'Months' },
  { value: 'Y', label: 'Years' }
];

function decodeValue(value) {
  if (value && value.length > 1) {
    return {
      quantity: `${parseInt(value, 10) || ''}`,
      unit: value.substring(value.length - 1).toUpperCase()
    };
  }
  return {
    quantity: '',
    unit: ''
  };
}

function encodeValue(value) {
  return `${value.quantity}${value.unit}`;
}

function isEncoded(value) {
  const unit = value.substring(value.length - 1).toUpperCase();
  return !!UNITS.find(u => u.value === unit);
}

class TermFieldComponent extends ValidatableField {
  constructor(props) {
    super(props);
    this.state = Object.assign(this.state, decodeValue(props.value));

    this.quantityField = null;
    this.unitFIeld = null;
  }

  static get propTypes() {
    return {
      label: PropTypes.string,
      value: PropTypes.any,
      editing: PropTypes.bool,
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      required: PropTypes.bool,
      validationMessage: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      validationMessage: 'Please enter a term'
    };
  }

  componentWillReceiveProps(props) {
    if (this.props.value !== props.value) {
      this.setState(
        decodeValue(props.value),
        () => this.validate()
      );
    }
  }

  validate() {
    return (!this.quantityField || this.quantityField.validate())
        && (!this.unitField || this.unitField.validate());
  }

  onChange() {
    const { onChange } = this.props;
    const { quantity, unit } = this.state;

    if (this.validate()) {
      onChange(encodeValue({ quantity, unit }));
    }
  }

  onChangeQuantity(quantity) {
    if (isEncoded(quantity)) {
      this.setState(decodeValue(quantity), () => this.onChange());
    } else {
      this.setState({ quantity }, () => this.onChange());
    }
  }

  onChangeUnit(unit) {
    this.setState({ unit }, () => this.onChange());
  }

  render() {
    const { label, name, editing, required, validationMessage, unitLabel } = this.props;
    const { quantity, unit } = this.state;

    return (
      <div className="TermField">
        <div className="FieldsContainer-group">
          <TextField
            ref={(instance) => { this.quantityField = instance; }}
            className="quantity"
            name={`${name}-quantity`}
            required={required}
            inputType={FIELD_TYPE.TERM}
            onChange={updatedValue => this.onChangeQuantity(updatedValue)}
            label={label}
            value={quantity}
            editing={editing}
            validationMessage={validationMessage}
          />

          <DropdownField
            ref={(instance) => { this.unitField = instance; }}
            name={`${name}-unit`}
            required={required}
            onChange={updatedValue => this.onChangeUnit(updatedValue.value)}
            label={unitLabel}
            value={{ value: unit }}
            editing={editing}
            possibleValues={UNITS}
            className="unit"
          />
        </div>
      </div>
    );
  }
}

export default TermFieldComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/TermField.js